import { http } from "../plugin/http2-common";

class MaskImageService {
  findBySurveyId(surveyId) {
    return http.get("/mask-image/list/" + surveyId);
  }
}

export default new MaskImageService();
